import * as types from '@/store/integration/actionTypes';
// eslint-disable-next-line import/no-cycle
import {
  deleteIntegration,
  listIntegrationsByCategory,
  loadIntegrationDetails,
  loadIntegrationOptionsList,
  loadIntegrations, runIntegration,
  saveNewIntegration, testIntegration,
} from '@/services/repository';
import {
  SET_INTEGRATIONS_PAGINATION_STATE,
} from '@/store/pagination/mutationTypes';
import {
  CLEAR_INTEGRATION_BY_CATEGORY,
  CLEAR_INTEGRATION_DETAILS, CLEAR_INTEGRATION_DETAILS_FOR_EDIT,
  CLEAR_INTEGRATION_OPTIONS_LIST, CLEAR_INTEGRATION_TESTING_LOADING,
  CLEAR_INTEGRATIONS,
  CLEAR_INTEGRATIONS_LIST_OPTIONS, SET_INTEGRATION_BY_CATEGORY,
  SET_INTEGRATION_DETAILS,
  SET_INTEGRATION_DETAILS_FOR_EDIT,
  SET_INTEGRATION_OPTIONS_LIST, SET_INTEGRATION_TESTING_LOADING,
  SET_INTEGRATIONS,
  SET_INTEGRATIONS_LIST_LOADING,
  SET_INTEGRATIONS_LIST_OPTIONS,
} from '@/store/integration/mutationTypes';

export default {
  async [types.TEST_INTEGRATION]({ commit }, integrationPayload) {
    try {
      commit(SET_INTEGRATION_TESTING_LOADING, true);
      await testIntegration(integrationPayload);
      // eslint-disable-next-line no-useless-catch
    } catch (e) {
      throw e;
    } finally {
      commit(CLEAR_INTEGRATION_TESTING_LOADING);
    }
  },
  // eslint-disable-next-line no-empty-pattern
  async [types.EXECUTE_INTEGRATION]({ }, integrationPayload) {
    await runIntegration(integrationPayload);
  },
  async [types.CLEAR_INTEGRATION_DETAILS]({ commit }) {
    commit(CLEAR_INTEGRATION_DETAILS);
  },
  // eslint-disable-next-line no-empty-pattern
  async [types.SAVE_INTEGRATION]({}, payload) {
    try {
      await saveNewIntegration(payload);
    } catch (e) {
      console.error(e);
    }
  },
  async [types.SET_INTEGRATION_DETAILS_FOR_EDIT]({ commit }, payload) {
    try {
      commit(SET_INTEGRATION_DETAILS_FOR_EDIT, payload);
    } catch (e) {
      console.log(e);
      commit(CLEAR_INTEGRATION_DETAILS_FOR_EDIT);
    }
  },
  async [types.CLEAR_INTEGRATION_DETAILS_FOR_EDIT]({ commit }) {
    commit(CLEAR_INTEGRATION_DETAILS_FOR_EDIT);
  },
  async [types.LOAD_INTEGRATION_DETAILS]({ commit }, payload) {
    try {
      const integrationDetails = await loadIntegrationDetails(payload);
      commit(SET_INTEGRATION_DETAILS, integrationDetails);
    } catch (e) {
      commit(CLEAR_INTEGRATION_DETAILS);
    }
  },
  async [types.LOAD_INTEGRATIONS_BY_CATEGORY]({ commit }, payload) {
    try {
      const integrationsPerCategory = await listIntegrationsByCategory(payload);
      commit(SET_INTEGRATION_BY_CATEGORY, integrationsPerCategory);
    } catch (e) {
      commit(CLEAR_INTEGRATION_BY_CATEGORY);
    }
  },
  async [types.LOAD_INTEGRATION_OPTIONS_LIST]({ commit }) {
    try {
      const integrationOptionsList = await loadIntegrationOptionsList();
      commit(SET_INTEGRATION_OPTIONS_LIST, integrationOptionsList);
    } catch (e) {
      commit(CLEAR_INTEGRATION_OPTIONS_LIST);
    }
  },
  async [types.CLEAR_INTEGRATIONS_LIST_OPTIONS]({ commit }) {
    commit(CLEAR_INTEGRATIONS_LIST_OPTIONS);
  },
  async [types.CHANGE_INTEGRATIONS_LIST_OPTIONS]({ commit, dispatch, getters }, options) {
    let search = '';

    if (options.searchUpdated) {
      search = options.search;
    } else {
      search = options.search === undefined ? getters.integrationListOptions.search : options.search;
    }
    commit(SET_INTEGRATIONS_LIST_OPTIONS, {
      sort: options.sort || getters.integrationListOptions.sort,
      limit: options.limit || getters.integrationListOptions.limit,
      page: options.page || getters.integrationListOptions.page,
      search,
    });
    await dispatch(types.LOAD_INTEGRATIONS, {
      sort: options.sort,
      limit: options.limit,
      page: options.page,
      search: options.search,
      turnOnLoading: options.turnOnLoading,
    });
  },
  async [types.LOAD_INTEGRATIONS]({ commit, getters }, payload) {
    try {
      if (payload.turnOnLoading) {
        commit(SET_INTEGRATIONS_LIST_LOADING, true);
      }

      const {
        items, page, pageCount, count, total,
      } = await loadIntegrations(
        {
          sort: payload.sort || getters.integrationListOptions.sort,
          limit: payload.limit || getters.integrationListOptions.limit,
          page: payload.page || getters.integrationListOptions.page,
          search: payload.search === undefined ? getters.integrationListOptions.search : payload.search,
        },
      );
      commit(SET_INTEGRATIONS_PAGINATION_STATE, {
        page,
        pageCount,
        count,
        total,
      });
      commit(SET_INTEGRATIONS, items);
    } catch (e) {
      commit(CLEAR_INTEGRATIONS);
    } finally {
      commit(SET_INTEGRATIONS_LIST_LOADING, false);
    }
  },
  async [types.DELETE_INTEGRATION]({ dispatch, getters }, payload) {
    await deleteIntegration(payload);
    await dispatch(types.LOAD_INTEGRATIONS, {
      sort: getters.integrationListOptions.sort,
      limit: getters.integrationListOptions.limit,
      page: getters.integrationListOptions.page,
      search: getters.integrationListOptions.search,
      turnOnLoading: true,
    });
  },
};
